function formatDate(value) {
  if (!value) {
    return '';
  }

  const date = new Date(typeof value === 'string' ? value.replace(' ', 'T') : value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('nb-NO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function AdminInquiryListSection({ inquiries }) {
  return (
    <section className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.9)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
      <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Henvendelser</p>
      <h2 className="font-serif text-2xl font-semibold text-[#163127]">Innkomne henvendelser</h2>

      {inquiries.length === 0 ? (
        <p className="mt-4 text-sm text-[#7c6b52]">Ingen henvendelser enna.</p>
      ) : (
        <ul className="mt-5 grid gap-4">
          {inquiries.map((inquiry) => (
            <li className="rounded-[20px] border border-[#18322814] bg-[rgba(255,255,255,0.7)] p-4" key={inquiry.id}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="font-semibold text-[#163127]">{inquiry.name}</span>
                <span className="text-xs text-[#7c6b52]">{formatDate(inquiry.createdAt)}</span>
              </div>
              {inquiry.propertyName ? (
                <p className="mt-1 text-sm text-[#355046]">
                  Eiendom: <span className="font-semibold">{inquiry.propertyName}</span>
                </p>
              ) : (
                <p className="mt-1 text-sm text-[#7c6b52]">Generell henvendelse</p>
              )}
              {inquiry.email ? <p className="mt-1 text-sm text-[#355046]">E-post: {inquiry.email}</p> : null}
              {inquiry.phone ? <p className="mt-1 text-sm text-[#355046]">Telefon: {inquiry.phone}</p> : null}
              <p className="mt-2 whitespace-pre-line text-[1.02rem] leading-[1.6] text-[#355046]">{inquiry.message}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default AdminInquiryListSection;
